import * as _ from 'lodash/fp';

import { init } from '@process-advisor/process-miner/processMiner/processMiner';
import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { methods } from '@process-advisor/process-miner/api/methods/methods';
import type { Diagram } from '@process-advisor/process-miner/types';
import { setEventEmitter} from '@process-advisor/process-miner/api/eventEmitter'

export const apiProvider = (() => {
    setEventEmitter()
    let eventEmitter = getEventEmitter()
    let diagram: Diagram;

    const setDiagram = (diagramInstance: Diagram) => {
        diagram = diagramInstance;
        (window as any).diagram = diagram;
    };

    const getDiagram = () => diagram;

    const getMethods = () => _.flowRight(
        _.reduce((allMethods, methodName) => ({
            ...allMethods,
            [methodName]: (props) => diagram
                && methods[methodName]({ diagram, eventEmitter, ...props }),
        }), {}),
        _.keys
    )(methods);
    const api = getMethods() as undefined as typeof methods;

    return {
        setDiagram,
        getDiagram,
        on: (name, listener) => eventEmitter.on(name, listener),
        off: (name, listener) => eventEmitter.off(name, listener),
        eventEmitter,
        init: () => init(),
        ...api,
    };
})();
